module.exports = __webpack_public_path__ + "static/img/pipeline_256.1d9c70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pipeline_256.png
// module id = 8kCM
// module chunks = 0